'use client';
import './mobile-round-stepper.css';

import { useRoundProgress } from '@wt/game/providers/roundProgress/RoundProgressProvider';
import useAnimatedRouter from '@wt/shared/hooks/useAnimatedRouter';
import { memo, useState } from 'react';

const MobileRoundSteps = memo(function MobileRoundSteps(props: {
  elements: JSX.Element[];
}) {
  return <ol className="mobile-wt-round-steps">{props.elements}</ol>;
});

export const MobileRoundStepper = memo(function MobileRoundStepper({
  closeStepper,
}: {
  closeStepper: () => void;
}) {
  const { animatedRoute } = useAnimatedRouter();
  const {
    currentRound,
    numRoundsCompleted,
    viewingResults,
    puzzle,
    puzzleId,
    gameMode,
  } = useRoundProgress();
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const gotoRound = (e: any) => {
    const target = e.currentTarget;
    if (target && target instanceof HTMLSpanElement) {
      const r = target.getAttribute('data-index');
      e.preventDefault();
      e.stopPropagation();
      if (Number(r) === currentRound) {
        setIsOpen(false);
        setTimeout(closeStepper, 400);
      } else if (Number(r) <= numRoundsCompleted) {
        gameMode != 'daily' && puzzleId
          ? animatedRoute(`/${gameMode}/game/${puzzleId}/results/${r}`)
          : animatedRoute('/game/results/' + r);
      } else if (viewingResults && Number(r) === numRoundsCompleted + 1) {
        gameMode != 'daily' && puzzleId
          ? animatedRoute(`/${gameMode}/game/${puzzleId}`)
          : animatedRoute('/game');
      } else {
        setIsOpen(false);
        setTimeout(closeStepper, 400);
      }
    }
    return false;
  };

  return (
    <div className="flex grow flex-col items-center">
      <MobileRoundSteps
        elements={Array.from({ length: puzzle.length }).map((r, index) => {
          const roundNumber = index + 1;
          let cls = 'mobile-wt-round-step';

          if (roundNumber <= numRoundsCompleted) {
            cls += ' active';
          }
          if (roundNumber === numRoundsCompleted && viewingResults) {
            cls += ' most-recent';
          }
          if (roundNumber === currentRound) {
            cls += ' current';
          }
          if (viewingResults) {
            cls += ' results';
          }

          if (roundNumber !== 1) {
            cls += isOpen
              ? ' animate-staggered-expand'
              : ' animate-staggered-collapse';
          }

          const delay = isOpen ? `${100 * index}ms` : `${100 * (4 - index)}ms`;

          return (
            <li
              key={'round-' + index}
              className={cls}
              style={{ animationDelay: delay }}
            >
              <span onClick={gotoRound} data-index={index + 1}>
                {index + 1}
              </span>
            </li>
          );
        })}
      />
    </div>
  );
});
